<template>
  <div>
    <q-select
      v-model="model"
      use-input
      input-debounce="0"
      :label="label"
      option-label="type"
      option-value="id"
      :emit-value="emitValue"
      map-options
      :disable="disable"
      hint=""
      :use-chips="multiple"
      :multiple="multiple"
      :loading="deviceTypesLoading"
      :options="options"
      @filter="filterFn"
      @input="$emit('changed', model)"
    >
      <template v-slot:no-option>
        <q-item>
          <q-item-section class="text-grey"> No results </q-item-section>
        </q-item>
      </template>
    </q-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    props: {
      id: {
        default: null,
      },
      label: {
        type: String,
        default: "Assign Device",
      },
      multiple: {
        type: Boolean,
        default: false,
      },
      disable: {
        type: Boolean,
        default: false,
      },
      filterOrganizationsID: {
        default: null,
      },
      filterApplicationsID: {
        default: null,
      },
      allowOwned: {
        default: false,
      },
      emitValue: {
        default: true,
      },
    },
    computed: {
      ...mapGetters({
        currentUser: "auth/currentUser",
        deviceTypes: "deviceTypes/list",
        deviceTypesLoading: "deviceTypes/listLoading",
      }),
    },
    watch: {
      id: function () {
        this.init();
      },
      deviceTypes: function () {
        this.init();
      },
      filterOrganizationsID: function () {
        this.init();
      },
    },
    data: () => ({
      model: null,
      options: [],
    }),
    mounted() {
      this.init();
    },
    methods: {
      init() {
        let deviceTypes = this.getDeviceTypesList();

        this.options = deviceTypes;
        let idList = null;
        if (this.multiple && this.id) {
          idList = this.id.split(",").map(function (x) {
            return parseInt(x, 10);
          });
        } else {
          idList = this.id;
        }
        this.model = idList;
      },
      filterFn(val, update) {
        let deviceTypes = this.getDeviceTypesList();

        if (val === "") {
          update(() => {
            this.options = deviceTypes;
          });
          return;
        } else {
          update(() => {
            const needle = val.toLowerCase();
            this.options = deviceTypes.filter(
              (v) => v.id.toLowerCase().indexOf(needle) > -1
            );
          });
        }
      },
      getDeviceTypesList() {
        let deviceTypes = JSON.parse(JSON.stringify(this.deviceTypes));
        if (this.filterOrganizationsID) {
          deviceTypes = deviceTypes.filter(
            (d) =>
              d.organizations_id == this.filterOrganizationsID &&
              (!d.ownerships_id || !this.allowOwned) &&
              !d.deployments_id
          );
        }
        if (this.filterApplicationsID) {
          deviceTypes = deviceTypes.filter(
            (d) =>
              d.applications_id == this.filterApplicationsID &&
              (!d.ownerships_id || !this.allowOwned) &&
              !d.deployments_id
          );
        }
        return deviceTypes;
      },
    },
  };
</script>
